import { jsx } from 'react/jsx-runtime';
import { InputBase } from '../InputBase/InputBase.js';
import '@headlessui/react';
import 'clsx';
import '@react-icons/all-files/bs/BsLayersFill.js';
import '@react-icons/all-files/bs/BsStars.js';
import '@react-icons/all-files/cg/CgSidebarOpen.js';
import '@react-icons/all-files/cg/CgSidebarRight.js';
import '@react-icons/all-files/fa/FaChevronDown.js';
import '@react-icons/all-files/fa/FaRedditSquare.js';
import '@react-icons/all-files/fa/FaSalesforce.js';
import '@react-icons/all-files/fa/FaSlack.js';
import '@react-icons/all-files/fa/FaTelegram.js';
import '@react-icons/all-files/fa6/FaSquareXTwitter.js';
import '@react-icons/all-files/md/MdAdd.js';
import '@react-icons/all-files/md/MdCheck.js';
import '@react-icons/all-files/md/MdClose.js';
import '@react-icons/all-files/md/MdEmail.js';
import '@react-icons/all-files/md/MdErrorOutline.js';
import '@react-icons/all-files/md/MdHelpOutline.js';
import '@react-icons/all-files/md/MdInfoOutline.js';
import '@react-icons/all-files/md/MdLanguage.js';
import '@react-icons/all-files/md/MdLink.js';
import '@react-icons/all-files/md/MdMoreVert.js';
import '@react-icons/all-files/md/MdOutlineThumbDown.js';
import '@react-icons/all-files/md/MdOutlineThumbUp.js';
import '@react-icons/all-files/md/MdOutlineWarningAmber.js';
import '@react-icons/all-files/md/MdPerson.js';
import '@react-icons/all-files/md/MdPhone.js';
import '@react-icons/all-files/md/MdShare.js';
import '@react-icons/all-files/rx/RxExternalLink.js';

function InputText({ type = "text", name, label, placeholder, description, rules, value, defaultValue, maxLength, disabled, autoComplete, onChange, textFormatter, }) {
    return (jsx(InputBase, { type: type, name: name, label: label, placeholder: placeholder, description: description, rules: rules, value: value, defaultValue: defaultValue, maxLength: maxLength, disabled: disabled, autoComplete: autoComplete, onChange: onChange, textFormatter: textFormatter }));
}

export { InputText };
//# sourceMappingURL=InputText.js.map
